import { useTranslation } from "react-i18next";

import { InputText, Text } from "@pentabd/ui";

export const PayScaleRow = ({
  payScaleMin,
  payScaleMax,
  register,
}: {
  payScaleMin: string;
  payScaleMax: string;
  register: any;
}) => {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div className="col-md-12 col-lg-3">
        <Text weight="semibold" color="title" size="sm">
          {t(
            "EMPLOYEE.POSTINGS_INFO.FORM.POSTING_RECORDS_INFO.PAY_SCALE.LABEL",
          )}
        </Text>
      </div>

      <div className="d-flex justify-content-center gap-9 align-items-center col-md-12 col-lg-7">
        <div className="flex-fill">
          <InputText
            {...register(payScaleMin)}
            disabled
            suffix={
              <Text size="sm" color="subtitle1">
                {t(
                  "EMPLOYEE.POSTINGS_INFO.FORM.POSTING_RECORDS_INFO.PAY_SCALE.PLACEHOLDER",
                )}
              </Text>
            }
          />
        </div>
        <Text weight="semibold" color="title" size="sm">
          {t("EMPLOYEE.POSTINGS_INFO.FORM.POSTING_RECORDS_INFO.PAY_SCALE.TO")}
        </Text>
        <div className="flex-fill">
          <InputText
            {...register(payScaleMax)}
            disabled
            suffix={
              <Text size="sm" color="subtitle1">
                {t(
                  "EMPLOYEE.POSTINGS_INFO.FORM.POSTING_RECORDS_INFO.PAY_SCALE.PLACEHOLDER",
                )}
              </Text>
            }
          />
        </div>
      </div>
    </div>
  );
};
